import {
    CREATE_ONBOARDING_NOVA_CONTA_PENDING,
    CREATE_ONBOARDING_NOVA_CONTA_SUCCESS,
    CREATE_ONBOARDING_NOVA_CONTA_FAILURE,
} from './actionTypes';

const initialState = { list: null, loading: false }

function onboardingReducer(state = initialState, action) {

    switch (action.type) {
        case CREATE_ONBOARDING_NOVA_CONTA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_ONBOARDING_NOVA_CONTA_SUCCESS:
        case CREATE_ONBOARDING_NOVA_CONTA_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { onboardingReducer };
